import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { getAssetsImageService, getAssetsLogoService, getLogoService } from '../../../services/services';
import { deleteLogoImageService, updateImageService, updateLogoService } from '../../../services/adminServices';

import { ListAdminAccount } from 'MyAccountPlus-UIComponents';

const initialState: ListAdminAccount = {
    loading: false,
    error: "",
    cache: "",
    logoSuccess: "",
    imageSuccess: "",
    deleteSuccess: "",
    assetLogos: [],
    assetImages: [],
    logo: null,
}

export const getAssestLogosThunk = createAsyncThunk("listAdminAccount/getAssestLogosThunk", async () => {
    try {
        const { data } = await getAssetsLogoService();
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getAssestImagesThunk = createAsyncThunk("listAdminAccount/getAssestImagesThunk", async () => {
    try {
        const { data } = await getAssetsImageService();
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getFerryLogoThunk = createAsyncThunk("listAdminAccount/getFerryLogoThunk", async (arg: string) => {
    try {
        const { data } = await getLogoService(arg);
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const updateLogoThunk = createAsyncThunk("listAdminAccount/updateLogoThunk", async (arg: File) => {
    try {
        const payload = {
            files: arg
        }
        const { data } = await updateLogoService(payload);
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const updateImagesThunk = createAsyncThunk("listAdminAccount/updateImagesThunk", async (arg: File) => {
    try {
        const payload = {
            files: arg
        }
        const { data } = await updateImageService(payload);
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const deleteImageLogoThunk = createAsyncThunk("listAdminAccount/deleteImageLogoThunk", async (arg: string) => {
    try {
        const { data } = await deleteLogoImageService(arg);
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})


export const listAdminAccountSlice = createSlice({
    name: 'listAdminAccount',
    initialState,
    reducers: {
        errorReducer: (state) => {
            state.error = ""
        },
        clearCacheReducer: (state) => {
            state.cache = ""
        },
        successReducer: (state) => {
            state.deleteSuccess = ""
            state.logoSuccess = ""
            state.imageSuccess = ""
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getAssestLogosThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getAssestLogosThunk.fulfilled, (state, action) => {
                state.assetLogos = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getAssestLogosThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getAssestImagesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getAssestImagesThunk.fulfilled, (state, action) => {
                state.assetImages = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getAssestImagesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getFerryLogoThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getFerryLogoThunk.fulfilled, (state, action) => {
                state.logo = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getFerryLogoThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(updateLogoThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(updateLogoThunk.fulfilled, (state, action) => {
                state.logoSuccess = "Logo uploaded successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(updateLogoThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(updateImagesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(updateImagesThunk.fulfilled, (state, action) => {
                state.imageSuccess = "Image uploaded successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(updateImagesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(deleteImageLogoThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(deleteImageLogoThunk.fulfilled, (state, action) => {
                state.deleteSuccess = "Logo/Image deleted successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(deleteImageLogoThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
    },
})

export const listAdminAccountActions = listAdminAccountSlice.actions;
export default listAdminAccountSlice.reducer;